const tableCellService = {
  photo: 'FOTO'
};

export default tableCellService;
